import React from "react";
import { StyledTitle } from "./Title.styled";

export const Title = (props) => {
	return <StyledTitle {...props} />;
};
